import React from 'react';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';
import { getUri } from 'services/generic';

import styles from './OptionNotPossibleConditions.module.scss';

type TermConditionsProps = {
  asteriskPrefix?: string;
  classes?: Partial<{
    container: string;
    wrapper: string;
    text: string;
  }>;
};

export default function OptionNotPossibleConditions({
  asteriskPrefix,
  classes,
}: TermConditionsProps): JSX.Element {
  const transAdditionalComponents = {
    cgvLink: (
      <a
        className={styles.termsLink}
        href={getUri('/terms-and-conditions')}
        target="_blank"
        rel="noreferrer"
      />
    ),
  };

  return (
    <div className={classNames(styles.termsBlock, classes?.container)}>
      <span className={classNames(classes?.wrapper)}>
        {asteriskPrefix?.length && (
          <span className={styles.asterisk}>{asteriskPrefix}</span>
        )}
        <span className={classNames(styles.termsSpan, classes?.text)}>
          <Trans
            i18nKey={'LABEL_OPTION_NOT_POSSIBLE'}
            namespace={'translation'}
            additionalComponents={transAdditionalComponents}
          />
        </span>
      </span>
    </div>
  );
}
